module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img30.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('a', {
    attrs: {
      "id": "ch14"
    }
  }), _vm._v("SLAVES COME TO VIRGINIA, 1619")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("I")]), _vm._v("n the early 1600s, Robert Rich, Earl of Warwick, wanted to trade in the Caribbean, but this conflicted with the pro-Spanish policies of his monarch, King James I. Blocked from legitimate trade, Rich proposed a privateer campaign in the Caribbean— quietly attacking Spanish shipping for profit under the secret commission of the King. The monarch of course would get a cut from the take. James approved.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1619, Rich’s ship, "), _c('i', [_vm._v("Treasurer")]), _vm._v(", captured a Spanish vessel with a cargo that included forty African slaves. The ship then headed north to Virginia to sell the slaves. Virginia Governor Yeardley felt this might anger the Spanish and threaten the supposedly neutral port of Jamestown. "), _c('i', [_vm._v("Treasurer’s")]), _vm._v(" captain quickly crossed to Bermuda and deposited half the slaves on a plantation owned by Robert Rich. "), _c('i', [_vm._v("Treasurer")]), _vm._v(" then returned, and its captain began negotiations with Yeardley. They divided the Africans, sending most to outlying plantations far from prying Spanish eyes. African Americans as slaves had come to Virginia. "), _c('span', {
    staticClass: "color"
  }, [_vm._v("(05-112)")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img32.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c6ac244","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter014.vue
// module id = 117
// module chunks = 0